import React from "react";
import "./compliance.css";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import pdfInfo from "../../assets/pdfs/Comunicado_Embajadores.pdf";
import embajadores from "../../assets/imgs/compliance_imgs/redesign-compliance/compliance-3.png";
import Swal from "sweetalert2";
import { FaUsers } from "react-icons/fa";

const Ambassadors = () => {
  const [tCompliance] = useTranslation("compliance");
  const [scrollY, setScrollY] = useState(0);
  const [animation6, setAnimation6] = useState(false);

  const showComunicate = () => {
    window.open(pdfInfo, "_blank");
  };

  const handlescroll = () => {
    setScrollY(window.scrollY || window.pageYOffset);
  };

  useEffect(() => {
    window.addEventListener("scroll", handlescroll);
    return () => window.removeEventListener("scroll", handlescroll);
  }, []);

  useEffect(() => {
    setAnimation6(scrollY >= 900);
  }, [scrollY]);

  const openVideoPopup = () => {
    Swal.fire({
      html: `
        <iframe width="460" height="340" src="https://www.youtube.com/embed/P1CtbyHZRRg?autoplay=1" frameborder="0" allowfullscreen></iframe>
        `,
      showCloseButton: true,
      showConfirmButton: false,
      focusConfirm: false,
      customClass: {
        popup: "sweetalert-video",
      },
    });
  };

  return (
    <article className="compliance-ambassadors-card">
      <div className="row g-0 align-items-stretch">
        <div className="col-12 col-md-5 compliance-ambassadors-card__visual">
          <img src={embajadores} alt="" className="compliance-ambassadors-card__img" />
        </div>
        <div className="col-12 col-md-7 compliance-ambassadors-card__content">
          <div
            className={
              animation6
                ? "compliance-ambassadors-card__icon animate__animated animate__fadeInUp"
                : "compliance-ambassadors-card__icon"
            }
            aria-hidden
          >
            <FaUsers />
          </div>
          <h3
            className={
              animation6
                ? "compliance-ambassadors-card__title animate__animated animate__fadeInUp"
                : "compliance-ambassadors-card__title"
            }
          >
            {tCompliance("body.embajadores")}
          </h3>
          <p className="compliance-ambassadors-card__text">
            {tCompliance("body.texto-embajadres")}
          </p>
          <div className="compliance-ambassadors-card__actions">
            <button
              type="button"
              className={
                animation6
                  ? "btn-ambassadors-primary me-2 animate__animated animate__fadeInUp"
                  : "btn-ambassadors-primary me-2"
              }
              id="btnComunicadoCompliance"
              onClick={showComunicate}
            >
              {tCompliance("body.btn-comunicate")}
            </button>
            <button
              type="button"
              className={
                animation6
                  ? "btn-ambassadors-outline animate__animated animate__fadeInUp"
                  : "btn-ambassadors-outline"
              }
              id="btnVideoCompliance"
              onClick={openVideoPopup}
            >
              {tCompliance("body.btn-video")}
            </button>
          </div>
        </div>
      </div>
    </article>
  );
};

export default Ambassadors;
